import { render, staticRenderFns } from "./ModulosPage.vue?vue&type=template&id=4d2d841b"
import script from "./ModulosPage.js?vue&type=script&lang=js&external"
export * from "./ModulosPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports